module.exports = __webpack_public_path__ + "img/exit.6c7d7f5b.png";